var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32 16.5L16.5 2L2 16.5","stroke":"black","strokeWidth":"3","strokeLinejoin":"round"}));
}

ArrowUp.defaultProps = {"width":"34","height":"18","viewBox":"0 0 34 18","fill":"none"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
